module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      优惠券\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "contentBox"
  }, [(_vm.listArrs.length == 0) ? _c('div', {
    staticClass: "noCash"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.listArrs.length > 0) ? _c('div', {
    staticClass: "cash"
  }, [_c('ul', {
    staticClass: "cash-ticket"
  }, _vm._l((_vm.listArrs), function(item) {
    return _c('li', [_c('div', {
      staticClass: "cash-coupon-item can_use"
    }, [_c('div', {
      staticClass: "cash-top clearfix"
    }, [_c('div', {
      staticClass: "money-box"
    }, [_c('span', {
      staticClass: "money-icon"
    }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
      staticClass: "money"
    }, [_vm._v(_vm._s(item.money_all.split('.')[0]))]), _vm._v(" "), _c('span', {
      staticClass: "cash-date"
    }, [_vm._v("有效期：" + _vm._s(item.set_time.split(' ')[0].replace('-', '.').replace('-', '.')) + " - " + _vm._s(item.end_time.split(' ')[0].replace('-', '.').replace('-', '.')))])]), _vm._v(" "), _c('div', {
      staticClass: "cash-type"
    }, [_c('span', [_vm._v("\n                    类型：\n                    "), (item.yhq_type == 1) ? _c('span', [_vm._v("现金券")]) : _vm._e(), _vm._v(" "), (item.yhq_type == 0) ? _c('span', [_vm._v("折扣券")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "cash-info"
    }, [_c('span', [_vm._v("[消费满" + _vm._s(item.money_need) + "元可用]")])])]), _vm._v(" "), _c('div', {
      staticClass: "cash-bottom clearfix"
    }, [_c('span', {
      staticClass: "cash-use"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t[" + _vm._s(item.remark) + "]\n\t\t\t\t\t\t\t\t")])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "clearfix pager-wrapper"
  }, [_c('div', {
    staticClass: "pagination",
    attrs: {
      "id": "pager"
    }
  }, [_c('span', {
    staticClass: "page-button pager-prev",
    class: {
      disabled: _vm.pager.page == 1
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, 'up')
      }
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('span', {
    staticClass: "page-info"
  }), _vm._v(" " + _vm._s(_vm.pager.page) + "/" + _vm._s(_vm.pager.count) + "\n\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "page-button pager-next",
    class: {
      disabled: _vm.pager.page == _vm.pager.count || _vm.pager.count == 0
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, "down")
      }
    }
  }, [_vm._v("下一页")])])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-empty-center"
  }, [_c('i', {
    staticClass: "ticket-empty-icon"
  }), _vm._v(" "), _c('h4', [_vm._v("暂无可使用的代金券哟~")]), _vm._v(" "), _c('p', [_vm._v("可以随便去看看有哪些想要产品与服务")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b42c0fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/cashcoupon.vue
// module id = f4YT
// module chunks = 1